import * as THREE from "three";
import { LineMaterial } from "three/addons";
import { STLLoader } from "three/addons/loaders/STLLoader.js";
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/addons/postprocessing/UnrealBloomPass.js';
import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';

export class MainMenuWebGl
{
    constructor( pageLoader )
    {
        this.init( pageLoader );
    }

    async init( pageLoader )
    {
        const stlLoader = new STLLoader();
        const geo = await stlLoader.loadAsync( '/assets/models/ahd-icon.svg_5mm.stl' );

        // Construct Wireframe model
        const edges = new THREE.EdgesGeometry( geo );
        let line = new THREE.LineSegments( edges );
        line.material.depthTest = false;
        line.material.color = new THREE.Color().setHex( 0xffffff );
        line.material.opacity = 0.5;
        line.material.transparent = true;

        line.geometry.center();
        line.position.set( 0, 0, 0 );
        line.scale.set( .03, .03, .03 );

        this.lineVertsMaxCount = line.geometry.getAttribute( 'position' ).count;
        this.lineVertsCurrent = 3;
        this.lineMesh = line;

        pageLoader.onProgress();
    }

    async show()
    {
        // Renderer
        const renderer = new THREE.WebGLRenderer(
            {
                canvas: document.querySelector( '#mainmenu-webgl'),
                antialias: true
            }
        );
        renderer.setClearColor( 0x1c1c1c, 1);
        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setSize( window.innerWidth, window.innerHeight );
        renderer.toneMapping = THREE.ReinhardToneMapping;
        renderer.toneMappingExposure = 0.2;

        // Camera
        const camera = new THREE.PerspectiveCamera( 70, window.innerWidth / window.innerHeight, 0.01, 10 );
        camera.position.z = 3;

        // Scene
        const scene = new THREE.Scene()
        scene.background = new THREE.Color().setHex( 0x1c1c1c );

        scene.add( this.lineMesh );

        // const renderScene = new RenderPass( scene, camera );
        //
        // const bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 0.4, 0.3, 1.50 );
        // bloomPass.threshold = 0.3;
        // bloomPass.strength = 1.10;
        // bloomPass.radius = 0.1;
        // const outputPass = new OutputPass();
        //
        // const composer = new EffectComposer( renderer );
        // composer.addPass( renderScene );
        // //composer.addPass( bloomPass );
        // composer.addPass( outputPass );

        // Expose
        this.scene = scene;
        this.renderer = renderer;
        this.camera = camera;
        //this.composer = composer;
        // RESIZE
        this.onWindowResize();
        window.addEventListener( 'resize', this.onWindowResize.bind( this ) );
        this.animate();
        this.animReqId = null;
    }

    onWindowResize( e )
    {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( window.innerWidth, window.innerHeight );

        if ( window.innerWidth > window.innerHeight )
        {
            this.lineMesh.scale.set( .03, .03, .03 );
        }
        else
        {
            this.lineMesh.scale.set( .021, .021, .021 );
        }
    }

    async hide()
    {
        window.cancelAnimationFrame( this.animReqId );
        window.removeEventListener( 'resize', this.onWindowResize.bind( this ) );
        this.lineVertsCurrent = 3;
        this.scene.remove( this.lineMesh );
        this.renderer.dispose();
        //this.composer.dispose();
    }

    animate( time )
    {
        this.lineMesh.rotation.x += 0.01;
        this.lineMesh.rotation.y += 0.005;

        if ( this.lineVertsCurrent < this.lineVertsMaxCount )
        {
            this.lineVertsCurrent += 6;
            this.lineMesh.geometry.setDrawRange(0, this.lineVertsCurrent );
        }

        this.renderer.render( this.scene, this.camera );
        //this.composer.render();

        this.animReqId = window.requestAnimationFrame( this.animate.bind( this ) );
    }
}
